import { computed, useContext } from '@nuxtjs/composition-api';
import {
  useSearchJobsCountQuery,
  SearchJobsCountQueryVariables,
  SearchJobInput,
} from '@/graphql/graphqlOperations';

export default function useSearchJobsCount(searchConditions: SearchJobInput) {
  const { route } = useContext();
  const searchJobsCountQueryVariables: SearchJobsCountQueryVariables = {
    conditions: searchConditions,
  };
  const {
    loading: jobCountLoading,
    result: jobCountResult,
    onResult: jobCountOnResult,
    onError: jobCountOnError,
    error: jobCountError,
  } = useSearchJobsCountQuery(searchJobsCountQueryVariables, {
    fetchPolicy: 'no-cache',
    /**
     * 説明会、企業実習の「開催地」「企業のタイプ」「業種」のページ（queryパラメータにtypeを持っている）では
     * ライブ表示のコンポーネントが表示が非表示のため無駄なqueryが走らないように制御する
     */
    enabled: !route.value.query.type,
  });

  const totalCount = computed(
    () => jobCountResult.value?.getTotalJobCount || 0
  );
  return {
    jobCountLoading,
    jobCountResult,
    jobCountOnResult,
    jobCountOnError,
    jobCountError,
    totalCount,
  };
}
